import { render, staticRenderFns } from "./ActivationEmail.vue?vue&type=template&id=4a59f775&scoped=true&"
import script from "./ActivationEmail.vue?vue&type=script&lang=js&"
export * from "./ActivationEmail.vue?vue&type=script&lang=js&"
import style0 from "./ActivationEmail.vue?vue&type=style&index=0&id=4a59f775&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a59f775",
  null
  
)

export default component.exports